import { SKTAction } from "../../components/SKTAction";
import { SKTBaseComponent } from "../../components/SKTBaseComponent";
import { SKTButton } from "../../components/SKTButton";
import { SKTForm } from "../../components/SKTForm";
import { SKTInfo } from "../../components/SKTInfo";
import { SKTPanel, SKTPanelBody } from "../../components/SKTPanel";
import { SKTTextField } from "../../components/SKTTextField";
import { useData } from "../../hooks/Data";
import { isValidEmail } from "../../utils/validators";

export const ForgotPasswordRequestForm = ({
  status,
  doRequestPasswordReset,
}) => {
  const data = useData({
    validators: {
      username: isValidEmail,
    },
  });

  const onClick = () => {
    doRequestPasswordReset(data.get("username"));
  };
  return (
    <SKTPanel>
      <SKTPanelBody>
        <SKTForm>
          <SKTInfo>
            <p>
              Unohditko salasanasi? Syötä sähköpostiosoitteesi lomakkeelle, niin
              lähetämme ohjeet, miten voit vaihtaa salasanan.
            </p>
            <p>{status}</p>
          </SKTInfo>
          <SKTTextField data={data} id="username" label="Sähköpostiosoite" />
          <SKTAction
            actionLabel="Haluan vaihtaa salasanani"
            onClick={onClick}
            active={true}
            type="btn-success"
          ></SKTAction>
        </SKTForm>
      </SKTPanelBody>
    </SKTPanel>
  );
};
